import { getCookie } from '@ynap/redux-cookies-middleware/src/cookieApi'; //eslint-disable-line monorepo/no-internal-import

import { getLocale, getHeadConfig } from '@ynap/config-state';

export const getAutomaticMarketingConsent = (state) => {
    const { country } = getLocale(state);
    const { automaticConsentCountryList } = getHeadConfig(state);

    if (automaticConsentCountryList) {
        const geoCountry = getCookie('geoIP');
        if (geoCountry) {
            return {
                automaticMarketingConsent: automaticConsentCountryList.includes(geoCountry) && automaticConsentCountryList.includes(country),
            };
        }
    }

    return {
        automaticMarketingConsent: false,
    };
};
